/**
 * GeoJSON / Geolatte Point에서 WGS84 경위도를 추출한다.
 * @param {unknown} geometry
 * @returns {{ lon: number, lat: number } | null}
 */
export function extractWgs84Point(geometry) {
  if (geometry == null) {
    return null;
  }

  if (Array.isArray(geometry) && geometry.length >= 2) {
    const lon = Number(geometry[0]);
    const lat = Number(geometry[1]);
    return Number.isFinite(lon) && Number.isFinite(lat) ? { lon, lat } : null;
  }

  if (typeof geometry !== 'object') {
    return null;
  }

  const coords =
    geometry.coordinates ??
    geometry.position?.coordinate ??
    geometry.position?.coordinates;

  if (!Array.isArray(coords) || coords.length < 2) {
    return null;
  }

  const lon = Number(coords[0]);
  const lat = Number(coords[1]);
  return Number.isFinite(lon) && Number.isFinite(lat) ? { lon, lat } : null;
}
